import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, Typography, Button } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import VerifiedIcon from "@mui/icons-material/Verified";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllPilots = () => {
  const [pilots, setPilots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [showEnquiry, setShowEnquiry] = useState(false);
const [selectedPilot, setSelectedPilot] = useState(null);
const [submitting, setSubmitting] = useState(false);

const [formData, setFormData] = useState({
  name: "",
  mobileNumber: "",
  email: "",
  address: "",
  description: "",
});


  useEffect(() => {
    fetchPilots();
  }, []);

  const fetchPilots = async () => {
    try {
      setLoading(true);
      setError("");

      const url = process.env.REACT_APP_API_URL;
      // const url = "http://localhost:6002"; // Replace with your actual API URL

      const response = await axios.get(
        `${url}/getAllPilot?page=1&limit=100`
      );

      console.log("All pilots response:", response);

      if (response.data.status === "success") {
        setPilots(response.data.data.data || []);
      } else {
        setError(response.data.message || "Failed to fetch pilots");
      }
    } catch (error) {
      console.error("Error fetching pilots:", error);

      setError(
        error.response?.data?.message ||
          "Something went wrong while fetching pilots."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEnquire = (pilot) => {
  setSelectedPilot(pilot);

  setFormData({
    name: "",
    mobileNumber: "",
    email: "",
    address: "",
    description: "",
  });

  setShowEnquiry(true);
};

const handleEnquiryChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmitEnquiry = async (e) => {
  e.preventDefault();

  if (!selectedPilot?._id) {
    toast.error("Pilot information is missing.");
    return;
  }

  try {
    setSubmitting(true);

    const payload = {
      pilotId: selectedPilot._id,
      name: formData.name.trim(),
      mobileNumber: formData.mobileNumber.trim(),
      email: formData.email.trim(),
      address: formData.address.trim(),
      description: formData.description.trim(),
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/pilot-enquiry`,
      payload
    );

    if (response.data.status === "success") {
      toast.success(
        "Enquiry submitted successfully. Our representative will contact you soon."
      );

      setShowEnquiry(false);
      setSelectedPilot(null);

      setFormData({
        name: "",
        mobileNumber: "",
        email: "",
        address: "",
        description: "",
      });
    } else {
      toast.error(
        response.data.message || "Failed to submit enquiry."
      );
    }
  } catch (error) {
    console.error("Pilot enquiry error:", error);

    toast.error(
      error.response?.data?.message ||
        "Something went wrong. Please try again."
    );
  } finally {
    setSubmitting(false);
  }
};

  return (
    <div
      style={{
        padding: "40px 20px",
        maxWidth: "1400px",
        margin: "0 auto",
      }}
    >
      {/* ================= HEADER ================= */}

      <div
        style={{
          textAlign: "center",
          marginBottom: "40px",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: "700",
            color: "#003580",
            marginBottom: "10px",
          }}
        >
          Drone Pilots
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#777",
            maxWidth: "700px",
            margin: "0 auto",
          }}
        >
          Connect with certified drone pilots for your
          professional drone operations and requirements.
        </Typography>
      </div>

      {/* ================= LOADING ================= */}

      {loading && (
        <div
          style={{
            textAlign: "center",
            padding: "50px",
          }}
        >
          <Typography>
            Loading pilots...
          </Typography>
        </div>
      )}

      {/* ================= ERROR ================= */}

      {!loading && error && (
        <div
          style={{
            textAlign: "center",
            padding: "50px",
          }}
        >
          <Typography color="error">
            {error}
          </Typography>
        </div>
      )}

      {/* ================= PILOT CARDS ================= */}

      {!loading && !error && (
        <>
          {pilots.length > 0 ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "25px",
              }}
            >
              {pilots.map((pilot) => (
                <Card
                  key={pilot._id}
                  sx={{
                    borderRadius: "16px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow:
                      "0 4px 20px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",

                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow:
                        "0 8px 28px rgba(0,0,0,0.14)",
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      padding: "25px",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    {/* ================= NAME ================= */}

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "15px",
                      }}
                    >
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#003580",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                      >
                        {pilot.name
                          ?.charAt(0)
                          ?.toUpperCase()}
                      </div>

                      <div>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "700",
                            color: "#333",
                          }}
                        >
                          {pilot.name}
                        </Typography>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            color: "#003580",
                            fontSize: "13px",
                          }}
                        >
                          <VerifiedIcon
                            sx={{ fontSize: "16px" }}
                          />

                          {pilot.userCategory}
                        </div>
                      </div>
                    </div>

                    {/* ================= DETAILS ================= */}

                    <div
                      style={{
                        borderTop:
                          "1px solid #eeeeee",
                        paddingTop: "15px",
                      }}
                    >
                      {/* Phone */}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "12px",
                        }}
                      >
                        <PhoneIcon
                          sx={{
                            fontSize: "18px",
                            color: "#003580",
                          }}
                        />

                        <Typography
                          variant="body2"
                          sx={{
                            color: "#555",
                            filter: "blur(5px)",
                            userSelect: "none",
                          }}
                        >
                          {pilot.number}
                        </Typography>
                      </div>

                      {/* DGCA CERTIFIED */}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "12px",
                        }}
                      >
                        <VerifiedIcon
                          sx={{
                            fontSize: "19px",
                            color: "#003580",
                          }}
                        />

                        <Typography
                          variant="body2"
                          sx={{
                            color: "#555",
                            fontWeight: "600",
                          }}
                        >
                          DGCA Certified
                        </Typography>
                      </div>

                      {/* Location */}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        <LocationOnIcon
                          sx={{
                            fontSize: "20px",
                            color: "#003580",
                          }}
                        />

                        <Typography
                          variant="body2"
                          sx={{
                            color: "#555",
                            lineHeight: 1.5,
                          }}
                        >
                          {pilot.district},{" "}
                          {pilot.state}
                          <br />
                          {pilot.pincode}
                        </Typography>
                      </div>
                    </div>

                    {/* ================= BUTTON ================= */}

                    <div
                      style={{
                        marginTop: "auto",
                        paddingTop: "25px",
                      }}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() =>
                          handleEnquire(pilot)
                        }
                        sx={{
                          backgroundColor: "#003580",
                          borderRadius: "8px",
                          padding: "10px",
                          fontWeight: "600",
                          textTransform: "none",

                          "&:hover": {
                            backgroundColor: "#197a9d",
                          },
                        }}
                      >
                        Enquire
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "50px",
              }}
            >
              <Typography
                variant="h6"
                sx={{ color: "#777" }}
              >
                No pilots found.
              </Typography>
            </div>
          )}
        </>
      )}

      {/* ================= PILOT ENQUIRY MODAL ================= */}

{showEnquiry && (
  <div
    className="fixed inset-0 z-[99999] bg-black/60 px-4 py-4"
    style={{
      overflow: "hidden",
    }}
  >
    <div className="w-full h-full flex items-center justify-center">

      {/* MODAL */}
      <div
        className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden"
        style={{
          maxHeight: "calc(100vh - 32px)",
          display: "flex",
          flexDirection: "column",
        }}
      >

        {/* ================= HEADER ================= */}

        <div
          className="bg-gradient-to-r from-blue-600 to-indigo-700 px-5 py-3 flex items-center justify-between"
          style={{
            flexShrink: 0,
          }}
        >
          <div>
            <h2 className="text-lg font-semibold text-white">
              Pilot Enquiry
            </h2>

            {selectedPilot && (
              <p className="text-sm text-blue-100 mt-1">
                Enquiring for {selectedPilot.name}
              </p>
            )}
          </div>

          <button
            type="button"
            onClick={() => setShowEnquiry(false)}
            disabled={submitting}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-white hover:bg-gray-100 transition"
          >
            <span className="text-gray-700 text-lg">
              ×
            </span>
          </button>
        </div>

        {/* ================= SCROLLABLE FORM ================= */}

        <div
          style={{
            overflowY: "auto",
            flex: 1,
            minHeight: 0,
          }}
        >
          <form
            onSubmit={handleSubmitEnquiry}
            className="px-5 py-4"
          >

            {/* NAME */}

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name
              </label>

              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleEnquiryChange}
                placeholder="Enter your name"
                required
                className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>

            {/* MOBILE */}

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Mobile Number
              </label>

              <input
                type="tel"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={(e) => {
                  const value = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 10);

                  setFormData((prev) => ({
                    ...prev,
                    mobileNumber: value,
                  }));
                }}
                placeholder="Enter 10 digit mobile number"
                maxLength={10}
                required
                className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>

            {/* EMAIL */}

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
                <span className="text-gray-400 font-normal">
                  {" "} (Optional)
                </span>
              </label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleEnquiryChange}
                placeholder="Enter your email"
                className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>

            {/* ADDRESS */}

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Address
              </label>

              <textarea
                name="address"
                value={formData.address}
                onChange={handleEnquiryChange}
                placeholder="Enter your address"
                rows={2}
                required
                className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
              />
            </div>

            {/* DESCRIPTION */}

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>

              <textarea
                name="description"
                value={formData.description}
                onChange={handleEnquiryChange}
                placeholder="Tell us about your requirement..."
                rows={3}
                required
                className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
              />
            </div>

            {/* BUTTONS */}

            <div className="flex justify-end gap-3 pt-2">

              <button
                type="button"
                onClick={() => setShowEnquiry(false)}
                disabled={submitting}
                className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 text-sm font-medium transition"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={submitting}
                className="px-5 py-2 rounded-lg bg-[#003580] text-white hover:bg-[#197a9d] text-sm font-semibold transition disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {submitting
                  ? "Submitting..."
                  : "Submit Enquiry"}
              </button>

            </div>

          </form>
        </div>

      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default AllPilots;